import React, {useRef, useEffect, useState, useCallback} from 'react';
import { ProGallery, } from 'pro-gallery';
import 'pro-gallery/dist/statics/main.css';
import { collection, query, limit, where, startAfter, documentId, doc, orderBy} from "firebase/firestore";
import { firestore, auth } from "../firebase";
import {
    useFirestoreInfiniteQuery,
} from "@react-query-firebase/firestore";
import Imgix from "react-imgix";
import { useScrollLock } from '@mantine/hooks';
import axios from "axios";
import { useSearchParams } from "react-router-dom";
import AppLoadingAnimation from "./AppLoadingAnimation";
import { saveAs } from "file-saver";
import ButonEvidentiaza from "./ButonEvidentiaza";
import PhotoSwipe from 'photoswipe';
import 'photoswipe/style.css';
import {Title} from "@mantine/core";

function download(url, name) {
    axios({
        url,
        method:'GET',
        responseType: 'blob'
    })
        .then((response) => {
            const url = window.URL
                .createObjectURL(new Blob([response.data]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', name);
            document.body.appendChild(link);
            link.click();
        })
}
const firebasePictureToGallery = (doc, index, pageIndex) => {
    const photo = doc.data();
    return {
        ...photo,
        index,
        url: `https://d2uqrxzbny1jco.cloudfront.net/fit-in/2000x2000/${photo.s3_path}`,
        src: `https://d2uqrxzbny1jco.cloudfront.net/fit-in/2000x2000/${photo.s3_path}`,
        title: `${photo.name}`,
        width: parseInt(photo?.width) || 500,
        height: parseInt(photo?.height) || 500,
        id: doc.id,
        orderIndex: index+pageIndex,
        metaData: {
            type: 'image',
            height: 200,
            width: 100,
            title: 'sample-title',
            description: 'sample-description',
            focalPoint: [0, 0],
            link: {
                url: 'http://example.com',
                target: '_blank'
            },
        },
        featured: photo.featured || false,
    }

}

export default function Gallery ({board, options, container, scrollingElement, onEvent, userId, isSearch, selected, disableFullscreen, isAdmin, isLoading, isHighlightsPhotos}) {

    const [pictures,  setPictures] = useState([]);
    const [scrollLocked, setScrollLocked] = useScrollLock();
    const [searchParams, setSearchParams] = useSearchParams();

    const [currentPhotoId, setCurrenPhotoId] = useState(null);

    const [fullScreenIdx, setFullScreenIdx] = useState(-1);


    const postsCollection = collection(firestore, "photos");
    let postsQuery = null;
    if (isSearch) {
        postsQuery = query(postsCollection, limit(100), where("board", "==", board), where("people","array-contains", userId), orderBy("name", "asc"));
    } else {
        if (isAdmin) {
            if(isHighlightsPhotos){
                postsQuery = query(postsCollection, limit(100), where("board", "==", board), where("featured","==", true), orderBy("name", "asc"));
            } else {
                postsQuery = query(postsCollection, limit(100), where("board", "==", board), orderBy("name", "asc"));
            }
        } else {
            postsQuery = query(postsCollection, limit(100), where("board", "==", board), where("featured","==", true), orderBy("name", "asc"));
        }
    }

    const posts = useFirestoreInfiniteQuery(["pictures", userId, board, isSearch], postsQuery, (snapshot) => {
        const lastDocument = snapshot.docs[snapshot.docs.length - 1];
        if (!lastDocument) {
            return undefined;
        }
        // Get the next 20 documents starting after the last document fetched.
        return query(postsQuery, startAfter(lastDocument));
    }, {}, { refetchOnWindowFocus: false, refetchOnReconnect: false });


    useEffect(() => {
        if (fullScreenIdx > -1) {
            setScrollLocked(true);
        } else {
            setScrollLocked(false);
        }
    }, [fullScreenIdx])

    useEffect(() => {
        return () => {
            try {
                if (window.lightbox) {
                    window.lightbox.destroy();
                    window.lightbox = null;
                }
            } catch (e) {
                console.log(e);
            }
        }
    }, [])
    useEffect(() => {
        if (posts?.data) {
            let temp = [];
            posts?.data?.pages?.forEach((page, pageIndex) => page.docs.forEach((doc, index) => temp.push(firebasePictureToGallery(doc, index, pageIndex))))
            setPictures([...temp]);
        }
    }, [posts?.data])

    useEffect(() => {
        let nodes = document.querySelectorAll(".imagine-selectata");

        let imgx = document.querySelectorAll('.gallery-item-wrapper');
        if(disableFullscreen === true){
            imgx.forEach(node => {
                node.classList.add('blank-checkbox');
            })
        } else {
            imgx.forEach(node => {
                node.classList.remove('blank-checkbox');
                node.classList.remove('filled-checkbox');
                //node.classList.remove('layer-background');
            })
        }


        nodes.forEach((node) => {
            if (!selected?.includes(node.dataset.id)) {
                node.classList.remove('imagine-selectata');
                node.querySelector(".gallery-item-wrapper").classList.remove('filled-checkbox');
                //node.classList.remove('layer-background');
            } 
        })

        selected?.forEach((id) => {
            document.querySelector(`div[data-id='${id}']`).classList.add("imagine-selectata");
            document.querySelector(`div[data-id='${id}']`).querySelector(".gallery-item-wrapper").classList.remove('blank-checkbox');
            document.querySelector(`div[data-id='${id}']`).querySelector(".gallery-item-wrapper").classList.add('filled-checkbox');
            //document.querySelector(`div[data-id='${id}']`).classList.add('layer-background');
        })
    }, [selected, disableFullscreen])



    const openLightBox = useCallback((index) => {
        let options = {
            zoom: false,
            counter: false,
            closeSVG: 
            `<div class="downloadButtonFullScreen">
                <svg xmlns="http://www.w3.org/2000/svg" class="icon icon-tabler icon-tabler-x" width="18" height="18" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" fill="none" stroke-linecap="round" stroke-linejoin="round">
                    <path stroke="none" d="M0 0h24v24H0z" fill="none"/>
                    <line x1="18" y1="6" x2="6" y2="18" stroke="white" />
                    <line x1="6" y1="6" x2="18" y2="18" stroke="white" />
                </svg>
            </div>`,
            dataSource: pictures,
            pswpModule: () => import('photoswipe')

        };

        options.index = index;

        let lightbox = new PhotoSwipe(options);

        lightbox.on('uiRegister', function() {
            lightbox.ui.registerElement({
                name: 'download-button',
                order: 8,
                isButton: true,
                tagName: 'a',
                html: 
                `<div class="downloadButtonFullScreen">
                    <svg xmlns="http://www.w3.org/2000/svg" class="icon icon-tabler icon-tabler-download" width="18" height="18" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" fill="none" stroke-linecap="round" stroke-linejoin="round">
                        <path stroke="none" d="M0 0h24v24H0z"/>
                        <path d="M4 17v2a2 2 0 0 0 2 2h12a2 2 0 0 0 2 -2v-2" stroke="white" />
                        <polyline points="7 11 12 16 17 11" stroke="white" />
                        <line x1="12" y1="4" x2="12" y2="16" stroke="white" />
                    </svg>
                </div>`,
                onInit: (el, pswp) => {
                    let photo = null;
                    el.onclick = () => {
                        saveAs(`${photo}`, "download.jpg");
                    }
                    pswp.on('change', () => {
                        photo = pswp.currSlide.data.src;
                    });
                }
            });
        });
        lightbox.init();
        window.lightbox = lightbox;
    }, [pictures])


    // sharpParams
    //     :
    //     blur
    //         :
    //         30
    // quality
    //     :
    //     30
    const resizeItem = useCallback((input) => {
        let blur = input.sharpParams.blur ? `/filters:blur(${input.sharpParams.blur || 0})` : "";
        let hd = input.sharpParams.blur ? 1 : 2;
        return `https://d2uqrxzbny1jco.cloudfront.net/filters:quality(${input.sharpParams.quality})${blur}/fit-in/${input.requiredWidth*hd}x${input.requiredHeight*hd}/${input.item.dto.s3_path}`;
    }, [])

    const eventsListener = useCallback((eventName, data) => {
        if (eventName === "NEED_MORE_ITEMS") {
            posts.fetchNextPage()
        }
        if (eventName === "ITEM_CLICKED" && !disableFullscreen) {
            openLightBox(data.idx);
            //setFullScreenIdx(data.idx);
            setCurrenPhotoId(data.id);
        }
        if (onEvent) {
            onEvent(eventName, data);
        }
    }, [onEvent, setFullScreenIdx, openLightBox])




    const renderImage = (imageProps) => <Imgix src={imageProps.src} loading={"eager"} width={imageProps.style.width} height={imageProps.style.height} onLoad={imageProps.onLoad} className={imageProps.className} />


    if (isLoading || posts.isLoading || (pictures.length === 0 && posts?.data?.pages?.[0]?.size > 0)) {
        return (
            <div id={"pro-gallery-default-dom-id"}>
                <div className="flex flex-col justify-center items-center pt-12">
                    <AppLoadingAnimation />
                </div>
            </div>
        )
    }


    if (posts?.data?.pages?.[0]?.size === 0) {
        if (isSearch) {
            return (
                <div id={"pro-gallery-default-dom-id"}>
                    <div className="flex flex-col justify-center items-center pt-12">
                        <Title order={3} align={'center'}>Ne pare rău, nu am găsit fotografii cu tine la acest eveniment</Title>
                        <AppLoadingAnimation type={"empty"}/>
                    </div>
                </div>
            );
        } else {
            return null;
        }
    }

    const downloadPhoto = () => {
        let found = pictures?.find((picture) => picture.id === currentPhotoId);
        saveAs(`https://d2uqrxzbny1jco.cloudfront.net/${found.s3_path}`, found.name);

    };


    return (
        <React.Fragment>
            {/*<LoadingOverlay visible={posts.isLoading}/>*/}
            <ProGallery
                id={"normal-gallery"}
                key={"normal-gallery"}
                customComponents={{
                    //customImageRenderer: renderImage,
                    customHoverRenderer: (isAdmin && !disableFullscreen) ? (itemProps) => <ButonEvidentiaza image={pictures[itemProps.idx]} board={board}/> : undefined
                }}
                items={pictures}
                createMediaUrl={resizeItem}
                options={{
                    ...options,
                    "layoutParams": {
                        "info": {
                            "placement": "ABOVE"
                        }
                    },
                    "behaviourParams": {
                        "item": {

                            // "clickAction": "MAGNIFY",
                            "overlay": {
                                "position": "BOTTOM",
                                "size": 32,
                                "hoveringBehaviour": "ALWAYS_VISIBLE"
                            },
                        }
                    }
                }}
                container={container}
                eventsListener={eventsListener}
                scrollingElement={scrollingElement}
            />

            {!isSearch && <><br/><br/></>}
        </React.Fragment>
    )
}